window.waitForGlobal = function(identifier, cb, poll) {
  var test = typeof identifier === "function" ? identifier : function() { return !!window[identifier]; };
  var interval;
  if(test()) {
    cb();
  } else {
    interval = setInterval(function(){
      if(test()) {
        cb();
        clearInterval(interval);
      }
    }, poll || 50);
  }
};

window.modulousQueue = (function() {
  var queue = [];
  var run = false;
  function runner(fn) {
    setTimeout(function(){
      try {
        fn();
      } catch (e) {
      }
    }, 0);
  }
  return {
     add: function(fn) {
       if (!run) queue.push(fn);
       if (run) runner(fn);
     },
     runAll: function() {
       var i = 0;
       run = true;
       for(;i<queue.length;i++) {
         runner(queue[i]);
       }
       queue = [];
     }
  };
}());

setTimeout(function(){
  waitForGlobal('jQuery', modulousQueue.runAll);
}, 5000);

/**
 * Global object to hold tracking related params/configs
 */
window.Tracking = {
  cobrand: null
};

window.Mobileweb = window.Mobileweb || {};
Mobileweb.getCookie = function(cname) {
  var name = cname + "=",
    ca = document.cookie.split(';'),
    i = 0,
    c,
    len;
  for (i, len = ca.length; i < len; i++) {
    c = ca[i];
    c = c.trim();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

function getQueryStringParameter(uri, key) {
  var re = new RegExp("([?|&])" + key + "=(.*?)(&|$)", "i");
  var separator = (uri.indexOf("?") !== -1 ? "&" : "?");
  var match = uri.match(re) || ["", "", ""];
  return match[2];
}
//decode base64_url
function base64Url_decode(encodedString) {
  encodedString = encodedString.replace(/-/g, '+').replace(/_/g,'/');
  return atob(encodedString);
}